import { forwardRef } from 'react';

import { IconProps } from './icons.types';

export const ArrowDownIcon = forwardRef<SVGSVGElement, IconProps>(function ArrowDownIcon(
  { color = '', height = 24, width = 24, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.6298 14.0541C11.8343 14.3153 12.1657 14.3153 12.3702 14.0541L14.8456 10.8917C15.1754 10.4704 14.9418 9.75 14.4754 9.75H9.52455C9.05816 9.75 8.82459 10.4704 9.15438 10.8917L11.6298 14.0541Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
